import { icon } from './common'

const elements = document.querySelectorAll( '.floating-logo' )
if( elements.length > 0 ) {
  for( const el of elements ) {
    // const container = el.querySelector( ':scope > .container' )
    // if( container ) {
      el.innerHTML += icon( 'svg-logo', 'floating-logo' )
    // }
  }
}

// list products
const nListProducts = document.querySelector('body.n-list-products .list-page')
if( nListProducts ) {
  const parent = nListProducts.parentElement
  parent.innerHTML += icon( 'svg-logo', 'floating-logo small' )
  parent.classList.add( 'floating-logo' )

}
